import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
// import { Redirect } from 'react-router-dom';
import {
  canvasToArrayBuffer,
  debouncer,
  distanceCylinder,
  getTargetPoint,
  getMaskAngle,
  sendMessageToParent,
  sleep,
  rectCoordsForCut,
} from '../../utils.js';
import Worker from '../../../workers/face.position.js';
import '@tensorflow/tfjs-backend-webgl';
import RootContext from '../../context';
import {
  DISTANCE_TO_COMPLETE,
  FACE_CUT_MIN_SIDE,
  FACE_CUT_SCALE,
  FACE_CUT_SHIFT_Y,
  MIN_SMOOTH_FPS,
  WRONG_POSITION_DEBOUNCE,
  COLOR_BORDER_WAITING,
  COLOR_BORDER_OK,
  COLOR_BORDER_BAD,
  ANGLE_MAX_YAW,
  ANGLE_MAX_ROLL,
  DEBUG,
  RADIUS_PROPORTION,
  ACTION_TIMEOUT,
  LIVENESS_UNAVAILABLE,
  LIVENESS_LOADING,
  LIVENESS_IN_PROCESS,
  HOLE_WH_COEFF,
  HOLE_W_COEFF,
  // const OFFSET_Y = isMobile() ? -30 : 20;
  OFFSET_Y,
  PROMPT_INITIAL,
  SUCCESS_POSITION_TIMEOUT,
} from '../../constants.js';
import {
  Area, Arrow, LivenessBack /* , LivnessButton */, Numbers,
} from './styles';
import history from '../../history';
import {
  PATH_ROOT, PATH_SUCCESS, PATH_NO_TIME_LEFT,
} from '../../paths';
import { Window } from '../../design/Window/Window';
import { apiGuaranted, apiLivenessStart } from '../../api';
// import arrow from '../../../assets/icons/arrow.svg';
import Loader from './Loader/Loader';

export const Liveness = () => {
  const projectId = localStorage.getItem('projectId');
  const sessionId = localStorage.getItem('sessionId');
  const {
    video, ctx, videoParams, model, /* tfBackend, */ setCaptureVideo,
  } = useContext(RootContext);
  console.log('[Liveness].render', {
    video, ctx, videoParams, model, setCaptureVideo,
  });
  videoParams || setCaptureVideo(true);
  const [faceInPosition, setFaceInPoition] = useState(null);
  // const [livenessState, setLivenessState] = useState(LIVENESS_UNAVAILABLE);
  const [prompt, setPrompt] = useState({
    isOk: false,
    message: ['Поместите лицо в овал'],
  });
  // const [keypoints, setKeypoints] = useState(null);
  const [counter, setCounter] = useState(null);
  const facePosition = useRef({});
  const livenessTimeout = useRef(null);
  const positionTimeout = useRef(null);
  const livenessTargets = useRef();
  const livenessState = useRef(LIVENESS_UNAVAILABLE);
  const isActive = useRef(true);
  const areaWidth = (window.innerWidth / 2) * HOLE_W_COEFF;
  const areaHeight = areaWidth * HOLE_WH_COEFF;
  const canvasPhotoRef = useRef();
  // const outerDivRef = useRef();

  const setActionTimeout = secondsLeft => {
    setCounter(secondsLeft);
    clearTimeout(livenessTimeout.current);
    livenessTimeout.current = setTimeout(() => {
      if (--secondsLeft <= 0) return history.push(`${PATH_ROOT}${PATH_NO_TIME_LEFT}`);
      setActionTimeout(secondsLeft);
    }, 1000);
  };

  const clearPositionTimeout = () => {
    clearTimeout(positionTimeout.current);
    positionTimeout.current = null;
  };

  const setPositionTimeout = (secondsLeft = 0) => {
    clearPositionTimeout();
    positionTimeout.current = setTimeout(() => {
      console.log(`face in position counter ${secondsLeft}`);
      if (++secondsLeft >= SUCCESS_POSITION_TIMEOUT) {
        return history.push(`${PATH_ROOT}${PATH_SUCCESS}`);
      }
      setPositionTimeout(secondsLeft);
    }, 1000);
  };

  const makeFacePhoto = async ({ landmarks }) => {
    console.log('[makeFacePhoto]', landmarks);
    try {
      const canvasPhoto = canvasPhotoRef.current;
      const context = canvasPhoto.getContext('2d');
      const [x, y, width, height] = rectCoordsForCut(
        landmarks, FACE_CUT_SCALE, FACE_CUT_SHIFT_Y
      );
      // console.log({
      //   x, y, width, height,
      // });
      const coeff = FACE_CUT_MIN_SIDE / Math.min(width, height);
      const cutWidth = Math.min(width, ctx.canvas.width - x);
      const cutHeight = Math.min(height, ctx.canvas.height - y);
      canvasPhoto.width = cutWidth * coeff;
      canvasPhoto.height = cutHeight * coeff;
      ctx.strokeStyle = '#22ff22';
      ctx.strokeRect(x, y, cutWidth, cutHeight);
      context.drawImage(
        ctx.canvas, x, y, cutWidth, cutHeight, 0, 0, canvasPhoto.width, canvasPhoto.height
      );
      // alert(`${x}, ${y}, ${width}, ${height}, ${cutWidth}, ${cutHeight},
      // ${canvasPhoto.width}, ${canvasPhoto.height}, ${ctx.canvas.width}, ${ctx.canvas.height}`);
      const image = await canvasToArrayBuffer(canvasPhoto);
      console.log({ image: image.byteLength });
      // window.log2.innerText = `image size: ${image.byteLength}`;

      if (livenessState.current === LIVENESS_UNAVAILABLE) {
        // init new liveness task
        console.warn('[makeFacePhoto] init new liveness task');
        changeLivenessState(LIVENESS_LOADING);
        const startLivenessResult = await apiGuaranted(apiLivenessStart, {
          project_id: projectId,
          session_id: sessionId,
          image,
        });
        console.log('[makeFacePhoto] init new liveness task response', { ...startLivenessResult });

        if (startLivenessResult.status === 'error') {
          alert(`API response error: ${JSON.stringify(startLivenessResult, null, ' ')}`);
          // canvasPhotoRef.current.style.visibility = 'visible';
          return;
        }
        if (startLivenessResult.status === 'info') {
          changeLivenessState(LIVENESS_UNAVAILABLE);
        }
        livenessTargets.current = [...startLivenessResult.tasks];
        console.log('[makeFacePhoto] new livenessTargets', livenessTargets.current);
        setActionTimeout(ACTION_TIMEOUT);
        changeLivenessState(LIVENESS_IN_PROCESS);
      } else if (livenessState.current === LIVENESS_IN_PROCESS) {
        console.warn('[makeFacePhoto] continue liveness task');
      }
    } catch (error) {
      console.error('[makeFacePhoto]', error);
    }
  };

  const startLivenessCheck = ({ landmarks }) => {
    console.warn('[startLivenessCheck] livenessState', livenessState.current);
    if (livenessState.current >= LIVENESS_LOADING) {
      changeLivenessState(LIVENESS_IN_PROCESS);
      return;
    }
    setPrompt({
      isOk: true,
      message: [],
    });
    makeFacePhoto({ landmarks });
  };

  const changeLivenessState = (state, message = []) => {
    // console.warn('[changeLivenessState]', state);
    // const LIVENESS_UNAVAILABLE = 0;
    // const LIVENESS_READY = 1;
    // const LIVENESS_LOADING = 2;
    // const LIVENESS_IN_PROCESS = 3;
    Array.isArray(message) || (message = [message]);
    console.log('[changeLivenessState]', { state, message });
    switch (state) {
      case LIVENESS_UNAVAILABLE:
        setPrompt({
          isOk: false,
          message,
        });
        break;
      case LIVENESS_LOADING:
        setPrompt({
          isOk: false,
          message: ['Загрузка задания'],
        });
        break;
      case LIVENESS_IN_PROCESS:
        positionTimeout.current || setPositionTimeout();
        setPrompt({
          isOk: true,
          // message: ['Кивните коловой вверх'],
          message: ['Держите голову ровно'],
        });
        break;
      default:
        break;
    }
    livenessState.current = state;
  };

  // const onChangeRadius = value => {
  //   RADIUS_PROPORTION = value;
  //   setRadius(window.innerWidth / RADIUS_PROPORTION);
  // };

  useEffect(() => {
    const centerAreaRect = window.document.getElementById('centerArea');
    console.log('[Liveness].useEffect', {
      video, ctx, videoParams, model, centerAreaRect,
    });
    // const canvas = document.getElementById('canvas');
    if (!videoParams || !centerAreaRect || !ctx || !video) return () => {};
    isActive.current = true;
    let maskAngle = [0, 0, 0];
    // window.videoResolution.innerText = `${videoParams.videoWidth}x${videoParams.videoHeight}`;
    // window.windowInner.innerText = `${window.innerWidth}x${window.innerHeight}`;
    // console.log({ ctx });
    // window.canvasResolution.innerText = `${ctx.innerWidth}x${ctx.innerHeight}`;
    // to del
    // ctx.fillStyle = '#f00';
    // ctx.fillRect(440, 330, 10, 10);
    // ctx.fillStyle = '#00f';
    // ctx.fillRect(100, 100, 10, 10);
    const radius = window.innerWidth / RADIUS_PROPORTION;
    // onChangeRadius(RADIUS_PROPORTION);
    const areaRect = centerAreaRect.getBoundingClientRect();
    // const canvasRect = canvas.getBoundingClientRect();
    // console.log({ canvasRect });
    const centerPoint = [
      // ctx.effectiveWidth / 2,
      ctx.width / 2,
      (areaRect.top + areaRect.height / 2) / (window.innerHeight / ctx.effectiveHeight),
      0,
    ];
    // let directionPointPrev = [0, 0, 0],
    // rectX,
    // rectY,
    // rectWidth,
    // rectHeight,
    let timeLine = [];
    const position = {
      count: timeLine.length && timeLine.length >= MIN_SMOOTH_FPS
        ? WRONG_POSITION_DEBOUNCE
        : WRONG_POSITION_DEBOUNCE / 2,
      inPosition: false,
    };

    // window.log2.innerText = logText;
    // directionPointPrev = [videoParams.videoWidth / 2, videoParams.videoHeight / 2 - OFFSET_Y, 0];
    // outerDivRef.current.style.width = isMobile() ? '100%' : `${videoParams.videoWidth}px`;
    const worker = new Worker();
    const workerCheckFacePosition = ({ landmarks }) => {
      // console.log('[workerCheckFacePosition]', landmarks);
      worker.onmessage = event => {
        const {
          inDistance,
          inCenter,
          tooClose,
          tooFar,
          // heightProportion,
          // widthProportion,
          // shiftX,
          // shiftY,
        } = event.data;
        // window.logRed.innerText = `h${heightProportion}%, w${widthProportion}%, sx${shiftX},
        // sy${shiftY}, yaw${Math.abs(maskAngle[0])}, roll${Math.abs(maskAngle[2])}`;
        const inAngles = Math.abs(maskAngle[0]) <= ANGLE_MAX_YAW
          && Math.abs(maskAngle[2]) <= ANGLE_MAX_ROLL;
        const faceOk = inDistance && inCenter && inAngles;
        if (debouncer({
          position,
          success: faceOk,
          maxCount: timeLine.length && timeLine.length >= MIN_SMOOTH_FPS
            ? WRONG_POSITION_DEBOUNCE
            : WRONG_POSITION_DEBOUNCE / 2,
        })) {
          setFaceInPoition(faceOk);
          if (!faceOk) {
            clearPositionTimeout();
            let message = '';
            if (tooClose) {
              message = 'Лицо слишком близко';
            } else if (tooFar) {
              message = 'Лицо слишком далеко';
            } else if (!inAngles) {
              message = 'Держите голову ровно';
            } else {
              message = 'Поместите лицо в овал';
            }
            setPrompt({
              isOk: false,
              message: [message],
            });
          } else {
            startLivenessCheck({ landmarks });
          }
          facePosition.current = {
            inDistance,
            inCenter,
            inAngles,
            tooFar,
            tooClose,
          };
        }
      };
      worker.postMessage({
        landmarks,
        // videoWidth: ctx.effectiveWidth,
        // videoHeight: ctx.effectiveHeight,
        videoWidth: ctx.canvas.width,
        videoHeight: ctx.canvas.height,
      });
    };

    const renderPrediction = async () => {
      if (!ctx) {
        await sleep(1);
        return renderPrediction();
      }
      const predictions = await model.estimateFaces({ input: ctx.canvas, predictIrises: false });
      ctx.drawImage(
        video,
        ctx.effectiveX,
        ctx.effectiveY,
        ctx.effectiveWidth,
        ctx.effectiveHeight,
        0,
        0,
        ctx.width,
        ctx.height
      );
      // console.log('ctx.effectiveWidth', ctx.effectiveWidth,
      // 'window.innerWidth', window.innerWidth);

      // const imageData = ctx.getImageData(0, 0, canvasWindth, canvasHeight);
      // console.log('imageData', imageData.width, imageData.height);
      // const predictions = await model.estimateFaces({ input: imageData });

      // console.log({
      //   inDistance: facePosition.current.inDistance, inCenter: facePosition.current.inCenter,
      // });
      // ctx.strokeStyle = facePosition.current.inDistance
      // && facePosition.current.inCenter ? '#22ff22' : '#ff2222';
      // ctx.strokeRect(rectX, rectY, rectWidth, rectHeight);

      // window.logAdditional.innerText = `vw/2:
      // ${videoParams.videoWidth / 2}, vh/2: ${videoParams.videoHeight / 2}`;
      // ctx.fillStyle = '#0f0';
      // ctx.fillRect(videoParams.videoWidth / 2, 100, 10, 10);
      if (predictions.length > 0) {
        try {
          predictions.forEach(prediction => {
            // console.log({ prediction });
            const landmarks = prediction.scaledMesh;
            maskAngle = getMaskAngle(prediction.scaledMesh);
            workerCheckFacePosition({ landmarks });
            // setKeypoints(landmarks);

            // show bound box
            // const [rectX, rectY, rectWidth, rectHeight] = rectCoordsForCut(
            //   landmarks, FACE_CUT_SCALE, FACE_CUT_SHIFT_Y
            // );
            // // console.log({
            // //   landmarks, rectX, rectY, rectWidth, rectHeight,
            // // });
            // ctx.strokeStyle = '#60ff60';
            // ctx.strokeRect(rectX, rectY, rectWidth, rectHeight);

            // show landmarks
            // for (let i = 0; i < landmarks.length; i++) {
            //   ctx.fillStyle = '#32EEDB';
            //   ctx.beginPath();
            //   ctx.arc(landmarks[i][0], landmarks[i][1], 1, 0, 2 * Math.PI);
            //   ctx.fill();
            // }

            // console.log('maskAngle', maskAngle);

            // show central point
            // ctx.fillStyle = '#22ff22';
            // ctx.fillRect(centerPoint[0], centerPoint[1], 5, 5);

            const directionPoint = getTargetPoint(
              maskAngle,
              centerPoint,
              radius,
              OFFSET_Y
              // directionPointPrev,
              // timeLine.length && timeLine.length >= MIN_SMOOTH_FPS
            );
            // directionPointPrev = directionPoint;
            if (DEBUG) {
              // window.logRed.innerText = directionPoint;
              ctx.fillStyle = '#fff';
              ctx.fillRect(directionPoint[0], directionPoint[1], 4, 4);
            }

            // liveness target zone
            // console.log('livenessTargets.current, inCenter, inDistance',
            // livenessTargets.current, facePosition.current.inCenter,
            // facePosition.current.inDistance);
            if (
              livenessTargets.current
              && livenessTargets.current.length
              && facePosition.current.inCenter
              && facePosition.current.inDistance
              && facePosition.current.inAngles
            ) {
              const currentTarget = livenessTargets.current[0];
              // console.log(`next point: ${currentTarget}`);
              const targetPoint = getTargetPoint(currentTarget, centerPoint, radius);
              // console.log(centerPoint, currentTarget, targetPoint);
              // window.log3.innerText = `next: ${currentTarget},
              // x${targetPoint[0]}, y${targetPoint[1]}`;

              // show target zone
              if (DEBUG) {
                ctx.beginPath();
                ctx.arc(targetPoint[0], targetPoint[1], DISTANCE_TO_COMPLETE, 0, 2 * Math.PI);
                ctx.strokeStyle = 'red';
                ctx.lineWidth = 2;
                ctx.stroke();
              }

              const distance = distanceCylinder(
                currentTarget[0], targetPoint[1], maskAngle[0], directionPoint[1], radius
              );
              // console.log({ distance });
              // window.log2.innerText = `distance: ${distance}`;
              if (distance <= DISTANCE_TO_COMPLETE) {
                setActionTimeout(ACTION_TIMEOUT);
                console.warn('catch match', { currentTarget });
                makeFacePhoto(landmarks);
                livenessTargets.current.shift();
                // console.log('livenessTargets.current.length after',
                // livenessTargets.current.length);
                livenessTargets.current.length || history.push(`${PATH_ROOT}${PATH_SUCCESS}`);
              }
            }
          });
        } catch (error) {
          alert(error);
        }
      } else {
        facePosition.current = {};
        setFaceInPoition(false);
        setPrompt(PROMPT_INITIAL);
      }
      timeLine.push(new Date());
      timeLine = timeLine.filter(item => new Date() - item <= 1000);
      // window.fps.innerText = `FPS: ${timeLine.length}`;
      isActive.current && requestAnimationFrame(renderPrediction);
    };
    renderPrediction();
    setActionTimeout(ACTION_TIMEOUT);
    return () => {
      // console.log('[useEffect].unmount');
      isActive.current = false;
      worker.terminate();
    };
    // eslint-disable-next-line
  }, [video, ctx, videoParams, model]);
  return <div>
    {
      faceInPosition && counter && false && <Arrow>
        {/*<img src={arrow} alt=""/>*/}
      </Arrow>
    }
    {
      videoParams && <Window
        isGood={prompt.isOk}
        isShow={!!prompt.message.length}
        textArr={prompt.message}
      />
    }
    <LivenessBack onClick={() => sendMessageToParent({ _: 'cancel' })}>
      Cancel
    </LivenessBack>
    <Numbers>
      {/* counter || '' */}
    </Numbers>
    <Area
      id="centerArea"
      borderColor={
        faceInPosition === null
          ? COLOR_BORDER_WAITING
          : faceInPosition
            ? COLOR_BORDER_OK
            : COLOR_BORDER_BAD
      }
      height={areaHeight}
      width={areaWidth}
      areaOpacity={1}
      borderWidth={7}
    />
    <canvas
      ref={canvasPhotoRef}
      style={{
        visibility: 'hidden',
        border: '1px solid red',
        position: 'fixed',
        top: 'calc(50vh - 50px)',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999999999,
      }}
    />
    { videoParams ? null : <Loader/> }
  </div>;
};

/*
    <LivnessButton
      disabled={livenessState !== LIVENESS_READY}
      onClick={startLivenessCheck}>{'Start liveness check'}
    </LivnessButton>

  <button onClick={() => newLivenessTarget()}>Start active liveness</button>

  <label><input type="checkbox" checked={RADIUS_PROPORTION === 5}
  onChange={() => onChangeRadius(5)} />R1</label>
  <label><input type="checkbox" checked={RADIUS_PROPORTION === 4.5}
  onChange={() => onChangeRadius(4.5)} />R2</label>
  <label><input type="checkbox" checked={RADIUS_PROPORTION === 4}
  onChange={() => onChangeRadius(4)} />R3</label>
  <label><input type="checkbox" checked={RADIUS_PROPORTION === 3.5}
  onChange={() => onChangeRadius(3.5)} />R4</label>

          style={{
            border: '1px solid red',
            position: 'fixed',
            bottom: '0px',
            right: '0px',
            zIndex: 10000,
          }}

https://storage.googleapis.com/tfhub-tfjs-modules/mediapipe/tfjs-model/facemesh/1/default/1/group1-shard1of1.bin
https://storage.googleapis.com/tfhub-tfjs-modules/mediapipe/tfjs-model/iris/1/default/2/group1-shard1of1.bin

    <div style={{ width: '100%' }}>
      <div
        ref={outerDivRef}
        style={{
          display: 'block',
          height: 'auto',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}>
        <div>
          <pre
            id="fps"
            style={{
              position: 'fixed',
              right: '100px',
              top: '20px',
              fontWeight: 'bold',
              fontSize: '20px',
              color: '#aa0000',
              zIndex: 10000,
            }}
          >
          </pre>
          <pre
            id="log3"
            style={{
              position: 'fixed',
              left: '20px',
              top: '20px',
              fontWeight: 'bold',
              fontSize: '20px',
              color: facePosition.inDistance && facePosition.inCenter ? '#22ff22' : '#ff2222',
              zIndex: 10000,
            }}
          >
            {
              livenessTargets.current
              && livenessTargets.current.length
                ? livenessTargets.current[livenessTargets.current.length - 1]
                : ''
            }
          </pre>
          <pre
            id="videoResolution"
            style={{
              position: 'fixed',
              left: '20px',
              top: '50px',
              fontWeight: 'bold',
              fontSize: '20px',
              color: '#aa0000',
              zIndex: 10000,
            }}
          >
          </pre>
          <pre
            id="windowInner"
            style={{
              position: 'fixed',
              left: '20px',
              top: '80px',
              fontWeight: 'bold',
              fontSize: '20px',
              color: '#aa0000',
              zIndex: 10000,
            }}
          >
          </pre>
          <pre
            id="logAdditional"
            style={{
              position: 'fixed',
              left: '20px',
              top: '110px',
              fontWeight: 'bold',
              fontSize: '20px',
              color: '#aa0000',
              zIndex: 10000,
            }}
          >
          </pre>
          <pre
            id="logRed"
            style={{
              position: 'fixed',
              left: '20px',
              top: '140px',
              fontWeight: 'bold',
              fontSize: '20px',
              color: '#aa0000',
              zIndex: 10000,
            }}
          >
          </pre>
        </div>
      </div>
    </div>
 */

